module.exports = __webpack_public_path__ + "img/AWAKEN-Landing_page-profile-renee.d0e19d9.png";